export const capacity = 'v1637684217/zen/static-assets/illustrations/660x660/man-mesuringHouse.svg'

export const purchase = 'v1637685716/zen/static-assets/illustrations/660x660/frame-man-cristalBall-right.svg'

export const renegotiation = 'v1637685716/zen/static-assets/illustrations/660x660/frame-people-call.svg'
